import { render, staticRenderFns } from "./CookRecord.vue?vue&type=template&id=008a682e&scoped=true"
import script from "./CookRecord.vue?vue&type=script&lang=js"
export * from "./CookRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008a682e",
  null
  
)

export default component.exports